import { render } from "./footer.vue?vue&type=template&id=503afc88"
const script = {}

import exportComponent from "/home/runner/work/admin-deppes/admin-deppes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__